/* Decorative SVG graphics used across the landing page */

export function Cloud({ width = 120, color = "#FFFFFF", opacity = 0.85, style = {}, className }) {
  return (
    <svg
      width={width}
      height={width * 0.55}
      viewBox="0 0 120 66"
      fill="none"
      style={{ position: "absolute", pointerEvents: "none", ...style }}
      aria-hidden="true"
      className={className}
    >
      <path
        d="M28 60c-12 0-22-8.5-22-19.5S16 21 28 21c2.5-11 12.5-19 24.5-19C65 2 75.5 9.5 78.5 20.5 79 20.4 79.7 20.4 80.4 20.4 92 20.4 114 26.6 114 40.2 114 51.5 105 60 93.5 60H28Z"
        fill={color}
        opacity={opacity}
      />
    </svg>
  );
}

export function StarBurst({ size = 34, color = "#EE7C3B", style = {}, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 34 34"
      fill="none"
      style={{ position: "absolute", pointerEvents: "none", ...style }}
      aria-hidden="true"
      className={className}
    >
      <path
        d="M17 1l3.2 10.4L31 8.2l-7.4 8L34 20l-10.8 1L25 32l-8-7.6L9 32l1.8-11L0 20l10.4-3.8L3 8.2l10.8 3.2L17 1Z"
        fill={color}
      />
    </svg>
  );
}

export function SparkleDoodle({ size = 26, color = "#3D4EAD", style = {}, className }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 26 26"
      fill="none"
      style={{ position: "absolute", pointerEvents: "none", ...style }}
      aria-hidden="true"
      className={className}
    >
      <path
        d="M13 1c1 6.5 5.5 11 12 12-6.5 1-11 5.5-12 12-1-6.5-5.5-11-12-12C7.5 12 12 7.5 13 1Z"
        fill={color}
      />
    </svg>
  );
}

export function Blob({ width = 220, color = "#F8CE85", opacity = 0.5, style = {}, className }) {
  return (
    <svg
      width={width}
      height={width * 0.82}
      viewBox="0 0 220 180"
      fill="none"
      style={{ position: "absolute", pointerEvents: "none", ...style }}
      aria-hidden="true"
      className={className}
    >
      <path
        d="M46.9 15.6C74.5-6.8 118.6-4.4 152.9 8.9c34.4 13.3 61 37.6 67.4 67.4 6.5 29.8-7.2 65.1-33.8 84.5-26.5 19.5-66 23.2-100.4 12.4C51.6 162.4 22.3 137 8.9 104.6-4.5 72.2-1 44.9 14.6 30.2c7.8-7.4 18.6-4.4 32.3-14.6Z"
        fill={color}
        opacity={opacity}
      />
    </svg>
  );
}

/* Hand-drawn curly arrow — used to point at the CTA */
export function CurlyArrow({ width = 90, color = "#181611", style = {} }) {
  return (
    <svg
      width={width}
      height={width * 0.62}
      viewBox="0 0 90 56"
      fill="none"
      style={{ position: "absolute", pointerEvents: "none", ...style }}
      aria-hidden="true"
    >
      <path
        d="M4 6c14 26 34 40 62 38m0 0-10-9m10 9-12 7"
        stroke={color}
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}

/* Tiny graduation-cap mascot face */
export function CapBuddy({ size = 54, style = {} }) {
  return (
    <svg
      width={size}
      height={size * 0.86}
      viewBox="0 0 54 46"
      fill="none"
      style={{ position: "absolute", pointerEvents: "none", ...style }}
      aria-hidden="true"
    >
      {/* cap */}
      <path d="M27 2 52 12 27 22 2 12 27 2Z" fill="#181611" />
      <path d="M42 17v8c0 2-6.7 5-15 5s-15-3-15-5v-8" stroke="#181611" strokeWidth="2.6" fill="#FDF8F0" />
      {/* tassel */}
      <path d="M50 13v10" stroke="#EE7C3B" strokeWidth="2.4" strokeLinecap="round" />
      <circle cx="50" cy="26" r="3.2" fill="#EE7C3B" />
      {/* face */}
      <circle cx="21" cy="36" r="2.4" fill="#181611" />
      <circle cx="35" cy="36" r="2.4" fill="#181611" />
      <path d="M23 41.5c2.4 2 5.6 2 8 0" stroke="#181611" strokeWidth="2.2" strokeLinecap="round" />
    </svg>
  );
}

/* Simple Nigeria map outline for the community band */
export function NigeriaMap({ width = 150, color = "#BFDFCE", style = {} }) {
  return (
    <svg
      width={width}
      height={width * 0.78}
      viewBox="0 0 150 116"
      fill="none"
      style={{ position: "absolute", pointerEvents: "none", ...style }}
      aria-hidden="true"
    >
      <path
        d="M22 34 48 22l24 4 20-12 22 6 14-8 8 18-10 16 6 20-14 22-18 6-10 14-22-4-16 8-14-12 4-18-12-14 6-16-6-18Z"
        stroke={color}
        strokeWidth="3"
        strokeLinejoin="round"
        fill="none"
      />
      <circle cx="88" cy="52" r="5" fill={color} />
    </svg>
  );
}
